{
  "journalAudit.action.design.org_charter.applied": "Organisation charter version applied",
  "journalAudit.action.design.org_charter.refused": "Organisation charter version refused",
  "v8b.charte.adresse_invalide": "Invalid address: no version has this number.",
  "v8b.charte.annuler": "Cancel",
  "v8b.charte.appliquee": "Version applied to projects",
  "v8b.charte.appliquee_info": "v{{version}} ({{semver}}), {{regime}}, validated by {{qui}} on {{le}}.",
  "v8b.charte.appliquer.bouton": "Apply the version",
  "v8b.charte.appliquer.effet_aucun": "No project has an open override: the version replaces the current one for all.",
  "v8b.charte.appliquer.effet_projets": "{{n}} project(s) affected, their open override becomes void: {{projets}}.",
  "v8b.charte.appliquer.succes": "Version applied. Written to the log.",
  "v8b.charte.appliquer.succes_projets": "Version applied; affected projects: {{projets}}. Written to the log.",
  "v8b.charte.appliquer.titre": "Apply version {{version}}",
  "v8b.charte.appliquer.verbe": "Apply",
  "v8b.charte.aucune_surcharge": "No project has requested an override.",
  "v8b.charte.aucune_validee": "No validated version: each project applies its own.",
  "v8b.charte.aucune_version": "No charter version yet: compose one.",
  "v8b.charte.champ.angles": "Corners",
  "v8b.charte.champ.densite": "Density",
  "v8b.charte.champ.fond": "Page background",
  "v8b.charte.champ.logo": "Logo",
  "v8b.charte.champ.palette": "Main colour",
  "v8b.charte.champ.typographie": "Typography",
  "v8b.charte.champ.voix": "Voice of labels",
  "v8b.charte.choix.angles.auto": "Following the typography",
  "v8b.charte.choix.angles.doux": "Rounded",
  "v8b.charte.choix.angles.droits": "Square",
  "v8b.charte.choix.angles.legers": "Slightly rounded",
  "v8b.charte.choix.angles.ronds": "Very rounded",
  "v8b.charte.choix.densite.aeree": "Airy",
  "v8b.charte.choix.densite.compacte": "Compact",
  "v8b.charte.choix.densite.standard": "Standard",
  "v8b.charte.choix.fond.blanc": "White",
  "v8b.charte.choix.fond.chaud": "Warm beige",
  "v8b.charte.choix.fond.froid": "Bluish grey",
  "v8b.charte.choix.fond.neutre": "Neutral grey",
  "v8b.charte.choix.fond.personnalisee": "Other background",
  "v8b.charte.choix.logo.aucun": "None",
  "v8b.charte.choix.logo.initiales": "Initials",
  "v8b.charte.choix.logo.nom": "Text logo",
  "v8b.charte.choix.palette.bleu-nuit": "Midnight blue",
  "v8b.charte.choix.palette.brique": "Brick",
  "v8b.charte.choix.palette.olive": "Olive",
  "v8b.charte.choix.palette.personnalisee": "Other colour",
  "v8b.charte.choix.palette.sarcelle": "Teal",
  "v8b.charte.choix.typographie.chaleureuse": "Warm",
  "v8b.charte.choix.typographie.sobre": "Plain",
  "v8b.charte.choix.typographie.technique": "Technical",
  "v8b.charte.choix.voix.tutoiement": "Informal address",
  "v8b.charte.choix.voix.vouvoiement": "Formal address",
  "v8b.charte.choix_en_mots": "Choices in words",
  "v8b.charte.code.COMPOSITION_HORS_MODELE": "The project model has no application: no composition.",
  "v8b.charte.code.CONTEXTE_INCOMPLET": "Incomplete context: the decision cannot be judged.",
  "v8b.charte.code.CREATEUR_N_APPROUVE_PAS": "You requested it: another person must decide.",
  "v8b.charte.code.DESIGN_CHARTER_NOT_DRAFT": "Only a draft can be validated.",
  "v8b.charte.code.DESIGN_CHARTER_OUTDATED": "Version older than the applied one.",
  "v8b.charte.code.DESIGN_CONTRAST_INSUFFICIENT": "Insufficient contrast: the gateway refuses this version.",
  "v8b.charte.code.DESIGN_ORG_CHARTER_ENFORCEMENT_REFUSED": "Only the applied version changes regime.",
  "v8b.charte.code.DESIGN_OVERRIDE_EXPIRED": "Override expired: the project must request a new one.",
  "v8b.charte.code.DESIGN_OVERRIDE_NOT_FOUND": "Override not found.",
  "v8b.charte.code.DESIGN_OVERRIDE_NOT_OPEN": "Override already decided or closed.",
  "v8b.charte.code.DESIGN_OVERRIDE_SELF_DECISION_REFUSED": "You requested it: another person must decide.",
  "v8b.charte.code.DESIGN_SELF_VALIDATION_REFUSED": "The author of a version never validates it.",
  "v8b.charte.code.DROIT_NON_TENU": "Your profile does not hold the required right.",
  "v8b.charte.code.GARDE_DROIT_ABSENTE": "Operation without a declared guard: refused.",
  "v8b.charte.code.IDEMPOTENCE_CONFLIT": "Request already sent with different content.",
  "v8b.charte.code.REFERENTIEL_ETAT_INCOMPATIBLE": "Action outside the expected state of the object.",
  "v8b.charte.code.REFERENTIEL_MOTIF_REQUIS": "Reason missing or too short.",
  "v8b.charte.code.REFERENTIEL_REPRISE_IMPOSSIBLE": "Cannot resume: source version not found or already validated.",
  "v8b.charte.code.RESOURCE_UNAVAILABLE": "Not found in your organisation.",
  "v8b.charte.code.SANS_SESSION": "Session expired: sign in again.",
  "v8b.charte.code.TECHNOLOGIE_NON_PROPOSABLE": "Stack not qualified: request a waiver.",
  "v8b.charte.code.VALIDATION_ERROR": "A mandatory field is missing or out of range.",
  "v8b.charte.code.VALIDATION_PAR_UN_TIERS": "Another person must validate: the author or a contributor never does.",
  "v8b.charte.code.WORKSPACE_ARCHIVED": "Archived project: nothing can be written.",
  "v8b.charte.composant.actuel": "{{role}}: {{element}}, {{n}} link(s).",
  "v8b.charte.composant.ajoute": "Component added to the launch draft.",
  "v8b.charte.composant.ajouter": "Add the component",
  "v8b.charte.composant.aucune_liaison": "No link possible: no other compatible role is present.",
  "v8b.charte.composant.aucune_pile": "No qualified element for this role.",
  "v8b.charte.composant.choisir": "— choose —",
  "v8b.charte.composant.element": "Element (qualified stack)",
  "v8b.charte.composant.element_requis": "Choose an element.",
  "v8b.charte.composant.enregistrer": "Save the changes",
  "v8b.charte.composant.incompatible": "Link now incompatible {{de}} → {{vers}} ({{motif}}): remove or replace it.",
  "v8b.charte.composant.lecture": "the project launch",
  "v8b.charte.composant.lecture_piles": "the catalogue stacks",
  "v8b.charte.composant.liaison": "{{de}} → {{vers}}",
  "v8b.charte.composant.liaisons": "Links",
  "v8b.charte.composant.modifie": "Component edited in the launch draft.",
  "v8b.charte.composant.non_qualifie": "{{pile}} (current, no longer qualified)",
  "v8b.charte.composant.non_qualifiee": "Composition not qualified:",
  "v8b.charte.composant.pas": "Step {{k}} of 3",
  "v8b.charte.composant.qualifiee": "Composition qualified.",
  "v8b.charte.composant.retire": "This component was removed in the meantime.",
  "v8b.charte.composant.retour": "Back to the launch",
  "v8b.charte.composant.rien": "Nothing to save: no change.",
  "v8b.charte.composant.role": "Role",
  "v8b.charte.composant.roles_pris": "Every role already has its component: edit one.",
  "v8b.charte.composant.titre_ajouter": "Add a component to the project",
  "v8b.charte.composant.titre_modifier": "Edit a project component",
  "v8b.charte.contraste.conforme": "compliant",
  "v8b.charte.contraste.insuffisant": "insufficient",
  "v8b.charte.editeur.apercu_bouton": "Button preview",
  "v8b.charte.editeur.apercu_texte.tutoiement": "You can save your work.",
  "v8b.charte.editeur.apercu_texte.vouvoiement": "You can save your work.",
  "v8b.charte.editeur.apercu_titre": "Your organisation",
  "v8b.charte.editeur.attente_source": "The resumed version must be readable before editing.",
  "v8b.charte.editeur.choix": "Version choices",
  "v8b.charte.editeur.contraste_a_verifier": "Contrast checked as you type: enter a valid colour.",
  "v8b.charte.editeur.contraste_conforme": "Contrast checked as you type: all pairs comply.",
  "v8b.charte.editeur.couleur_libre": "Main colour (#rrggbb)",
  "v8b.charte.editeur.effet_brouillon": "Saved as a draft: another person must validate it.",
  "v8b.charte.editeur.effet_reprise": "A revision linked to the resumed version is saved; the former validation lapses.",
  "v8b.charte.editeur.enregistrer": "Save the version",
  "v8b.charte.editeur.fond_libre": "Background colour (#rrggbb)",
  "v8b.charte.editeur.logo_texte": "Logo text",
  "v8b.charte.editeur.nom": "New version: v{{version}} (number assigned on save).",
  "v8b.charte.editeur.paire_insuffisante": "Insufficient contrast: {{paire}} ({{ratio}}).",
  "v8b.charte.editeur.titre": "Organisation charter — compose a version",
  "v8b.charte.effets.lecture": "the affected projects",
  "v8b.charte.effets.non_visibles": "The affected projects are not visible to your profile: the response will name them.",
  "v8b.charte.etat.chargement": "Loading {{quoi}}…",
  "v8b.charte.etat.en_cours": "In progress…",
  "v8b.charte.etat.erreur": "{{quoi}}: cannot be read right now.",
  "v8b.charte.etat.reessayer": "Retry",
  "v8b.charte.etat.refus": "{{quoi}}: reading refused for your profile.",
  "v8b.charte.etat_version.appliquee_imposee": "Applied to projects, enforced.",
  "v8b.charte.etat_version.appliquee_recommandee": "Applied to projects, recommended.",
  "v8b.charte.etat_version.brouillon": "Draft: another person must validate it.",
  "v8b.charte.etat_version.refusee_avec_motif_retour_a_l_auteur": "Refused with a reason, back to the author.",
  "v8b.charte.etat_version.remplacee": "Superseded by a more recent version.",
  "v8b.charte.etat_version.validee_pas_encore_appliquee": "Validated, not applied yet ({{regime}}).",
  "v8b.charte.fiche.applicateur": "Applied by",
  "v8b.charte.fiche.auteur": "Author",
  "v8b.charte.fiche.motif": "Refused by {{qui}}: “{{motif}}”. It goes back to its author.",
  "v8b.charte.fiche.source": "Resumed from",
  "v8b.charte.fiche.source_lien": "version no. {{id}}",
  "v8b.charte.fiche.titre": "Version",
  "v8b.charte.fiche.validateur": "Validated by",
  "v8b.charte.fiche.version": "Number",
  "v8b.charte.geste.erreur": "The action did not go through. Try again in a moment.",
  "v8b.charte.gestes": "Decisions",
  "v8b.charte.jetons.copier": "Copy the tokens",
  "v8b.charte.jetons.copies": "Tokens copied.",
  "v8b.charte.jetons.masquer": "Hide the tokens",
  "v8b.charte.jetons.voir": "Show the tokens",
  "v8b.charte.lecture_charte": "the organisation charter",
  "v8b.charte.lecture_source": "the resumed version",
  "v8b.charte.lecture_version": "the charter version",
  "v8b.charte.modifier": "Edit the charter",
  "v8b.charte.n_a_decider": "{{n}} to decide",
  "v8b.charte.onglet.catalogue": "Technology catalogue",
  "v8b.charte.onglet.charte": "Charter",
  "v8b.charte.onglet.chemin_dore": "Golden path",
  "v8b.charte.onglet.derogations": "Waivers",
  "v8b.charte.onglet.exigences": "Requirements",
  "v8b.charte.onglet.regles": "Three-step rules",
  "v8b.charte.onglet.sante": "Compliance health",
  "v8b.charte.onglets": "Organisation governance",
  "v8b.charte.origine.nouvelle_version_depuis_la_version_appliquee": "New version, from the applied version.",
  "v8b.charte.origine.reprise_d_un_brouillon": "Resuming a draft.",
  "v8b.charte.origine.reprise_d_une_version_refusee_motif_affiche": "Resuming a refused version: its reason is shown.",
  "v8b.charte.par_le": "by {{qui}} on {{le}}",
  "v8b.charte.refus.bouton": "Refuse the version",
  "v8b.charte.refus.motif": "Reason for refusal",
  "v8b.charte.refus.motif_court": "The reason must have at least {{n}} characters.",
  "v8b.charte.refus.succes": "Version refused: it goes back to its author with the reason.",
  "v8b.charte.regime.changer": "Change the regime",
  "v8b.charte.regime.confirmer": "Confirm",
  "v8b.charte.regime.effets_aucun": "No project has its own charter: nothing changes for them.",
  "v8b.charte.regime.effets_projets": "{{n}} project(s) will return to the charter: {{projets}}.",
  "v8b.charte.regime.effets_surcharges": "Overrides of the other regime become void.",
  "v8b.charte.regime.imposee": "enforced",
  "v8b.charte.regime.intro": "Version {{version}}, currently {{regime}}.",
  "v8b.charte.regime.je_confirme": "I confirm the switch to “{{regime}}”.",
  "v8b.charte.regime.recommandee": "recommended",
  "v8b.charte.regime.retour_version": "Back to the version",
  "v8b.charte.regime.succes": "Regime changed ({{regime}}); {{n}} override(s) now void; affected projects: {{projets}}. Written to the log.",
  "v8b.charte.regime.titre": "Change the charter regime — confirmation",
  "v8b.charte.regime.vise": "Target regime",
  "v8b.charte.reprendre.brouillon": "Resume the draft",
  "v8b.charte.reprendre.refusee": "Resume the refused version",
  "v8b.charte.role.donnees": "Data",
  "v8b.charte.role.interface": "Interface",
  "v8b.charte.role.service": "Service",
  "v8b.charte.role.service_de_plateforme": "Platform service",
  "v8b.charte.sans_organisation": "No organisation in your session: the charter cannot be read.",
  "v8b.charte.source_introuvable": "Version to resume not found or already validated: only a draft or refused version can be resumed.",
  "v8b.charte.source_motif": "Reason for refusal: “{{motif}}”",
  "v8b.charte.source_reprise": "Resumed version: v{{version}}, its content is preloaded.",
  "v8b.charte.statut.draft": "Draft to validate",
  "v8b.charte.statut.refused": "Refused",
  "v8b.charte.statut.superseded": "Superseded",
  "v8b.charte.statut.validated": "Applied",
  "v8b.charte.statut.validated_pending": "Validated, to apply",
  "v8b.charte.surcharge.accorder": "Grant the override",
  "v8b.charte.surcharge.aucun_ecart": "No deviation declared.",
  "v8b.charte.surcharge.decidee": "Override decided. Written to the log.",
  "v8b.charte.surcharge.decideur": "Decided by",
  "v8b.charte.surcharge.decision": "Decision",
  "v8b.charte.surcharge.demandeur": "Requested by",
  "v8b.charte.surcharge.ecart": "{{choix}}: organisation {{organisation}}, project {{projet}}",
  "v8b.charte.surcharge.ecarts": "Deviations from the charter",
  "v8b.charte.surcharge.echeance": "Expiry",
  "v8b.charte.surcharge.entre_temps": "This override was decided in the meantime: the record is read again.",
  "v8b.charte.surcharge.etat.a_decider": "To decide",
  "v8b.charte.surcharge.etat.accordee": "Granted",
  "v8b.charte.surcharge.etat.refusee": "Refused",
  "v8b.charte.surcharge.etat.terminee": "Ended",
  "v8b.charte.surcharge.fiche": "Override",
  "v8b.charte.surcharge.introuvable": "Override not found in your organisation.",
  "v8b.charte.surcharge.lecture": "the override",
  "v8b.charte.surcharge.mettre_fin": "End the override",
  "v8b.charte.surcharge.mettre_fin_effet": "Project {{projet}} returns to the organisation charter.",
  "v8b.charte.surcharge.mettre_fin_verbe": "End",
  "v8b.charte.surcharge.motif": "Reason",
  "v8b.charte.surcharge.motif_decision": "Reason for the decision",
  "v8b.charte.surcharge.projet": "Project",
  "v8b.charte.surcharge.refuser": "Refuse the override",
  "v8b.charte.surcharge.regime": "Target charter",
  "v8b.charte.surcharge.statut.active": "Granted",
  "v8b.charte.surcharge.statut.ended": "Ended",
  "v8b.charte.surcharge.statut.refused": "Refused",
  "v8b.charte.surcharge.statut.requested": "To decide",
  "v8b.charte.surcharge.statut_titre": "Status",
  "v8b.charte.surcharge.terminee": "Override ended: the project returns to the charter.",
  "v8b.charte.surcharge.titre": "Charter override requested by a project",
  "v8b.charte.surcharges": "Project overrides",
  "v8b.charte.surcharges_reservees": "Overrides of all projects are reserved to the organisation administration.",
  "v8b.charte.titre": "Organisation design charter",
  "v8b.charte.toute_la_charte": "Whole charter",
  "v8b.charte.validee_par": "validated by {{qui}}",
  "v8b.charte.valider.imposee": "Validate — enforced",
  "v8b.charte.valider.imposee_effet": "Once applied, the charter will be enforced: {{n}} project(s) with their own charter will return to it ({{projets}}).",
  "v8b.charte.valider.imposee_verbe": "Validate as enforced",
  "v8b.charte.valider.recommandee": "Validate — recommended",
  "v8b.charte.valider.succes": "Version validated, to apply: the applied version stays in place. Written to the log.",
  "v8b.charte.version_introuvable": "Version not found in your organisation.",
  "v8b.charte.version_n": "Version {{version}}",
  "v8b.charte.version_titre": "Organisation charter — version",
  "v8b.charte.versions": "Charter versions",
  "v8b.charte.vous": "you"
}
